export function handleExternalUrl(ctx) {
    const { permalink } = ctx.upsellInformation.cta_information ?? {};
    if (!permalink) {
        return;
    }
    // Defensively allowlist http(s) so a misconfigured backend payload can't open
    // javascript:/data: URLs. EXTERNAL_URL destinations are external pages (e.g. a
    // legal/policy page), so always open in a new tab rather than router.push.
    let parsed;
    try {
        parsed = new URL(permalink);
    }
    catch {
        return;
    }
    if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
        return;
    }
    window.open(parsed.href, '_blank', 'noopener,noreferrer');
}
//# sourceMappingURL=handleExternalUrl.js.map